import React from 'react';
import { MyListing } from '@/types/residents/marketplaceListing';
import { SVG_COMPONENTS } from '@/assets/admin';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { ListingRowCard } from './shared';

const ChevronRightIcon = SVG_COMPONENTS.CHEVRON_RIGHT;

interface MyListingCardProps {
  listing: MyListing;
  onPress: () => void;
}

export const MyListingCard: React.FC<MyListingCardProps> = ({
  listing,
  onPress,
}) => {
  return (
    <ListingRowCard
      imageUri={listing.images[0]?.url}
      price={listing.price}
      title={listing.title}
      condition={listing.condition}
      onPress={onPress}
      rightElement={
        <ChevronRightIcon width={20} height={20} color={MARKETPLACE_COLORS.textMuted} />
      }
    />
  );
};
